var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_39801",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8571 2.28564H1.14286C0.511675 2.28564 0 2.79732 0 3.4285V12.5714C0 13.2025 0.511675 13.7142 1.14286 13.7142H14.8571C15.4883 13.7142 16 13.2025 16 12.5714V3.4285C16 2.79732 15.4883 2.28564 14.8571 2.28564Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_39801)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8571 2.28564H1.14286C0.511675 2.28564 0 2.79732 0 3.4285V12.5714C0 13.2025 0.511675 13.7142 1.14286 13.7142H14.8571C15.4883 13.7142 16 13.2025 16 12.5714V3.4285C16 2.79732 15.4883 2.28564 14.8571 2.28564Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3_39801",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 12
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8571 2.28564H1.14286C0.511675 2.28564 0 2.79732 0 3.4285V12.5714C0 13.2025 0.511675 13.7142 1.14286 13.7142H14.8571C15.4883 13.7142 16 13.2025 16 12.5714V3.4285C16 2.79732 15.4883 2.28564 14.8571 2.28564Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3_39801)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2.28564H0V3.04755H16V2.28564ZM16 3.80946H0V4.57136H16V3.80946ZM0 5.33326H16V6.09517H0V5.33326ZM16 6.85707H0V7.61898H16V6.85707ZM0 8.3809H16V9.14279H0V8.3809ZM16 9.90467H0V10.6666H16V9.90467ZM0 11.4285H16V12.1904H0V11.4285ZM16 12.9523H0V13.7142H16V12.9523Z",
    fill: "#D02F44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85714 2.28564H0V7.61898H6.85714V2.28564Z",
    fill: "#46467F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3_39801)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.52387 3.42856C1.52387 3.63895 1.35331 3.80951 1.14292 3.80951C0.932523 3.80951 0.761963 3.63895 0.761963 3.42856C0.761963 3.21817 0.932523 3.04761 1.14292 3.04761C1.35331 3.04761 1.52387 3.21817 1.52387 3.42856ZM3.04768 3.42856C3.04768 3.63895 2.87712 3.80951 2.66673 3.80951C2.45633 3.80951 2.28577 3.63895 2.28577 3.42856C2.28577 3.21817 2.45633 3.04761 2.66673 3.04761C2.87712 3.04761 3.04768 3.21817 3.04768 3.42856ZM4.19053 3.80951C4.40093 3.80951 4.57149 3.63895 4.57149 3.42856C4.57149 3.21817 4.40093 3.04761 4.19053 3.04761C3.98014 3.04761 3.80959 3.21817 3.80959 3.42856C3.80959 3.63895 3.98014 3.80951 4.19053 3.80951ZM6.09527 3.42856C6.09527 3.63895 5.92476 3.80951 5.71435 3.80951C5.50395 3.80951 5.33339 3.63895 5.33339 3.42856C5.33339 3.21817 5.50395 3.04761 5.71435 3.04761C5.92476 3.04761 6.09527 3.21817 6.09527 3.42856ZM1.90482 4.57141C2.11521 4.57141 2.28577 4.40086 2.28577 4.19046C2.28577 3.98007 2.11521 3.80951 1.90482 3.80951C1.69443 3.80951 1.52387 3.98007 1.52387 4.19046C1.52387 4.40086 1.69443 4.57141 1.90482 4.57141ZM3.80959 4.19046C3.80959 4.40086 3.63903 4.57141 3.42863 4.57141C3.21824 4.57141 3.04768 4.40086 3.04768 4.19046C3.04768 3.98007 3.21824 3.80951 3.42863 3.80951C3.63903 3.80951 3.80959 3.98007 3.80959 4.19046ZM4.95244 4.57141C5.16284 4.57141 5.33339 4.40086 5.33339 4.19046C5.33339 3.98007 5.16284 3.80951 4.95244 3.80951C4.74205 3.80951 4.57149 3.98007 4.57149 4.19046C4.57149 4.40086 4.74205 4.57141 4.95244 4.57141ZM6.09527 4.95237C6.09527 5.16276 5.92476 5.33332 5.71435 5.33332C5.50395 5.33332 5.33339 5.16276 5.33339 4.95237C5.33339 4.74197 5.50395 4.57141 5.71435 4.57141C5.92476 4.57141 6.09527 4.74197 6.09527 4.95237ZM4.19053 5.33332C4.40093 5.33332 4.57149 5.16276 4.57149 4.95237C4.57149 4.74197 4.40093 4.57141 4.19053 4.57141C3.98014 4.57141 3.80959 4.74197 3.80959 4.95237C3.80959 5.16276 3.98014 5.33332 4.19053 5.33332ZM3.04768 4.95237C3.04768 5.16276 2.87712 5.33332 2.66673 5.33332C2.45633 5.33332 2.28577 5.16276 2.28577 4.95237C2.28577 4.74197 2.45633 4.57141 2.66673 4.57141C2.87712 4.57141 3.04768 4.74197 3.04768 4.95237ZM1.14292 5.33332C1.35331 5.33332 1.52387 5.16276 1.52387 4.95237C1.52387 4.74197 1.35331 4.57141 1.14292 4.57141C0.932523 4.57141 0.761963 4.74197 0.761963 4.95237C0.761963 5.16276 0.932523 5.33332 1.14292 5.33332ZM2.28577 5.71427C2.28577 5.92467 2.11521 6.09522 1.90482 6.09522C1.69443 6.09522 1.52387 5.92467 1.52387 5.71427C1.52387 5.50388 1.69443 5.33332 1.90482 5.33332C2.11521 5.33332 2.28577 5.50388 2.28577 5.71427ZM3.42863 6.09522C3.63903 6.09522 3.80959 5.92467 3.80959 5.71427C3.80959 5.50388 3.63903 5.33332 3.42863 5.33332C3.21824 5.33332 3.04768 5.50388 3.04768 5.71427C3.04768 5.92467 3.21824 6.09522 3.42863 6.09522ZM5.33339 5.71427C5.33339 5.92467 5.16284 6.09522 4.95244 6.09522C4.74205 6.09522 4.57149 5.92467 4.57149 5.71427C4.57149 5.50388 4.74205 5.33332 4.95244 5.33332C5.16284 5.33332 5.33339 5.50388 5.33339 5.71427ZM5.71435 6.85713C5.92476 6.85713 6.09527 6.68657 6.09527 6.47618C6.09527 6.26578 5.92476 6.09522 5.71435 6.09522C5.50395 6.09522 5.33339 6.26578 5.33339 6.47618C5.33339 6.68657 5.50395 6.85713 5.71435 6.85713ZM4.57149 6.47618C4.57149 6.68657 4.40093 6.85713 4.19053 6.85713C3.98014 6.85713 3.80959 6.68657 3.80959 6.47618C3.80959 6.26578 3.98014 6.09522 4.19053 6.09522C4.40093 6.09522 4.57149 6.26578 4.57149 6.47618ZM2.66673 6.85713C2.87712 6.85713 3.04768 6.68657 3.04768 6.47618C3.04768 6.26578 2.87712 6.09522 2.66673 6.09522C2.45633 6.09522 2.28577 6.26578 2.28577 6.47618C2.28577 6.68657 2.45633 6.85713 2.66673 6.85713ZM1.52387 6.47618C1.52387 6.68657 1.35331 6.85713 1.14292 6.85713C0.932523 6.85713 0.761963 6.68657 0.761963 6.47618C0.761963 6.26578 0.932523 6.09522 1.14292 6.09522C1.35331 6.09522 1.52387 6.26578 1.52387 6.47618Z",
    fill: "url(#paint0_linear_3_39801)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_39801",
    x: 0.761963,
    y: 3.04761,
    width: 5.33325,
    height: 32.381,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 28.5714
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_39801"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_39801",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_39801",
    x1: 0.761963,
    y1: 3.04761,
    x2: 0.761963,
    y2: 6.85713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsFlag);
export default __webpack_public_path__ + "static/media/USFlag.583622b38d10d5f6c48f1236af7b30ed.svg";
export { ForwardRef as ReactComponent };